function waitForJQuery(callback) {
    if (typeof jQuery !== "undefined") {
        callback();
    } else {
        setTimeout(() => waitForJQuery(callback), 100);
    }
}

waitForJQuery(() => {
    console.log("jQuery Loaded");
    window.dispatchEvent(new Event("jqueryLoaded"));
    const key = 'quiz_responses_v2';

    function changeTotalMeals(cart) { 
        const totalMeals = cart.items.reduce((acc, item) => acc + item.quantity, 0);
        let pkQty = JSON.parse(localStorage.getItem(key))?.pk_qty;
        if (!pkQty) {
            pkQty = $('.qtd-meal-btn.selected').data('pk-qty') || 0;
        }

        $('.quantity-meals').text(totalMeals);
        $('.total-meals').text(pkQty);
        if (totalMeals > pkQty) {
            $('.meals-quantity-total').addClass('hidden');
        } else {
            $('.meals-quantity-total').removeClass('hidden');
        }
        let widthBar = ((totalMeals / pkQty) * 100).toFixed(1);
            widthBar = Math.max(0, widthBar);
            widthBar = Math.min(widthBar, 100);

        $('.progress-total').css('width', widthBar + '%');
    }

    (function ($) {
        const methods = {
            async getCart() {
                try {
                    return await $.ajax({
                        type: "GET",
                        url: "/cart.js",
                        dataType: "json",
                    });
                } catch (err) {
                    console.error("Erro ao obter o carrinho:", err);
                    throw err;
                }
            },
            async addItem(data, discount = null) {
                try {
                    await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                        body: data,
                    });
                    if (discount != null) {
                        await fetch("/cart/update.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                updates: {},
                                discount: discount,
                            }),
                        });
                    }
                } catch (err) {
                    console.error("Erro ao adicionar item ao carrinho:", err);
                    throw err;
                }
            },

            async updateQuantityItem(lineKey, quantity) {
                try {
                    return await $.ajax({
                        type: "POST",
                        url: "/cart/update.js",
                        data: {
                            updates: {
                                [lineKey]: quantity,
                            },
                        },
                        dataType: "json",
                    });
                } catch (err) {
                    console.error(
                        "Erro ao atualizar a quantidade do item no carrinho:",
                        err
                    );
                    throw err;
                }
            },

            async clearCart() {
                return await $.ajax({
                    type: "POST",
                    url: "/cart/clear.js",
                    data: {},
                    dataType: "json",
                });
            },

            async addAttributes(attributes = {}) {
                try {
                    return await $.ajax({
                        type: "POST",
                        url: "/cart/update.js",
                        data: {
                            attributes: {
                            ...attributes
                            }
                        },
                        dataType: "json",
                    });
                } catch (err) {
                    console.error("Erro ao adicionar atributos ao carrinho:", err);
                    throw err;
                }
            },

            async addItems(products, discount = null, attributes = {}) {
                try {
                    const res = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            items: products,
                            discount: discount,
                        }),
                    });
                    if (discount != null) {
                        await fetch("/cart/update.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                updates: {},
                                discount: discount,
                                attributes: {
                                    ...attributes
                                }
                            }),
                        });
                    }
                    if (res.ok) {
                        return await res.json()
                    }
                } catch (e) {
                    throw new Error(e);
                }
            },
        };
        window.FormEvents = methods;
    })(jQuery);

    (function ($) {
        const methods = {
            async buildCart() {
                const cart = await FormEvents.getCart();
                const productFree = cart.items.find(item => item.id == 44860389982387);
                const productOneMonth = cart.items.find(item => item.product_title.includes('One-Month'));
                if (productFree && !productOneMonth) {
                    await FormEvents.updateQuantityItem(productFree.key, 0);
                }

                try {
                    const cartItemsSection = await $.ajax({
                        url: `/cart?section_id=cart-items`,
                    });
                    const cartTotal = await $.ajax({
                        url: `/cart?section_id=result-cart-total`,
                    });
                    const parser = new DOMParser();
                    const cartItemsContent = parser.parseFromString(cartItemsSection, 'text/html');
                    const cartTotalContent = parser.parseFromString(cartTotal, 'text/html');
                    const $listItems = $(cartItemsContent).find('#cart-items');
                    const $cartTotal = $(cartTotalContent).find('#cart-total');

                    if (!$listItems.length) {
                        console.warn('No cart items found in the response.');
                        return;
                    }
                    if (!$cartTotal.length) {
                        console.warn('No cart items found in the response.');
                        return;
                    }

                    $('#cart-items').empty().html($listItems);
                    $('#cart-total').empty().html($cartTotal);

                    /* Quantity items*/
                    const itemCount = cart.item_count;
                    let messageItems = itemCount > 1 ? 'Items' : 'Item';

                    $('.cart-items-count').html(`${itemCount} ${messageItems}`);
                    $('.go-to-checkout').prop('disabled', itemCount === 0);

                    /* Progress bar quantity meals */
                    changeTotalMeals(cart);

                    const pageHandle = sessionStorage.getItem('page_handle') ?? '';
                    const discount = document.querySelector('.discount-code');
                    const discountPartner = document.querySelector('.discount-partner');
                    const discountApply = document.querySelectorAll('.discount-code-wrapper');
                    const shippingBar = document.querySelector('.shipping-bar-wrapper');

                    if (pageHandle.includes('partner-')) {
                        discount.classList.add('hidden');
                        discountApply.forEach(el => el.classList.add('hidden'));
                        shippingBar.classList.add('hidden');
                        discountPartner.classList.remove('hidden');
                    } else {
                        discount.classList.remove('hidden');
                        discountApply.forEach(el => el.classList.remove('hidden')); 
                        shippingBar.classList.remove('hidden');
                        discountPartner.classList.add('hidden');
                    }

                    /* Shipping Bar Calculate*/
                    const shippingText = [
                        { threshold: 0, message: "Buy and Get Free Delivery 🚚" },
                        { threshold: 25, message: "Nice! Add a little more to unlock Free Delivery" },
                        { threshold: 50, message: "Almost there—Free Delivery is close 💪" },
                        { threshold: 75, message: "So close! Just a bit more for Free Delivery" },
                        { threshold: 100, message: "Congrats! You've unlocked Free Delivery 🎉" },
                    ];

                    function getShippingMessage(progress) {
                        let currentMessage = shippingText[0].message;
                        for (let i = 0; i < shippingText.length; i++) {
                            if (progress >= shippingText[i].threshold) {
                                currentMessage = shippingText[i].message;
                            } else {
                                break;
                            }
                        }
                        return currentMessage;
                    }

                    const cartTotalFormat = cart.total_price / 100;
                    const valueFreeShipping = $('.shipping-bar').data('shipping');
                    let width = ((cartTotalFormat / valueFreeShipping) * 100).toFixed(1);
                    width = Math.max(0, width);
                    width = Math.min(width, 100);

                    $('.cart-shipping-fill').css({
                        width: width + '%',
                    });
                    
                    const message = getShippingMessage(width);
                    $('.shipping-bar-text').text(message);
                    const storage = sessionStorage.getItem('confetti');
                    const popupFreeShipping = document.querySelector('.badge-free-shipping');

                    if (width >= 100 && !storage) {
                        sessionStorage.setItem('confetti', true);
                        popupFreeShipping.classList.remove('hidden');
                        setTimeout(() => {
                            popupFreeShipping.classList.add('hidden');
                        }, 7000);
                        let params = {
                            particleCount: 500, // Quantidade de confetes
                            spread: 90, // O quanto eles se espalham
                            startVelocity: 70, // Velocidade inicial
                            origin: { x: 0, y: 0.5 }, // Posição inicial na tela
                            angle: 45 // Ângulo em que os confetes serão lançados
                        };

                        // Joga confetes da esquerda pra direita
                        confetti(params);

                        // Joga confetes da direita para a esquerda
                        params.origin.x = 1;
                        params.angle = 135;
                        confetti(params);
                    }
                    document.dispatchEvent(new Event("buildcart"));
                } catch (err) {
                    console.error('Erro ao construir o carrinho:', err);
                }
            },
            async changeAtcButtonText() {
                try {
                    const cart = await FormEvents.getCart();
                    $('.product-card').each(function () {
                        const $productCard = $(this);
                        const productId = $productCard.data('variant-id');
                        const product = cart.items.find(item => item.id == productId);
                        if (product) {
                            $productCard.find('.quantity-wrapper').removeClass('hidden');
                            $productCard.find('#product-form-quantity').empty().text(product.quantity);
                            $productCard.find('#AddToCartButton').addClass('hidden');
                        } else {
                            $productCard.find('.quantity-wrapper').addClass('hidden');
                            $productCard.find('#AddToCartButton').removeClass('hidden');
                        }
                    });
                } catch (err) {
                    console.error("Erro ao alterar o texto do botão 'Add to Cart':", err);
                }
            },
            async initCart(page) {
                try {
                    const cart = await FormEvents.getCart();
                    const storage = localStorage.getItem(key);
                    const quizComplete = storage ? JSON.parse(storage).winner : null;
                    const getDiscountCode = quizComplete ? 'INTRO_80' : null;
                    const pkQty = storage
                        ? JSON.parse(storage)?.pk_qty || 6
                        : $('.qtd-meal-btn.selected').data('pk-qty') || 6;

                    let items = [];
                    $('.section-products__meal .product-card').each(function (index) {
                        if (index < pkQty) {
                        console.log("Adding product to cart:", index);
                        const $productCard = $(this);
                        const productId = $productCard.data('variant-id');
                        items.push({
                            id: productId,
                            quantity: 1,
                            selling_plan: $productCard.data('product-selling-plan-id'),
                            properties: {
                                "Option" : "custom",
                            },
                        });
                        }
                    });
                    return await FormEvents.addItems(items, getDiscountCode, {'Page': page});

                } catch (err) {
                    console.error("Erro ao inicializar o carrinho:", err);
                    throw err;
                }
            }
        };

        window.CartDrawerAPI = methods;
    })(jQuery);

    function verifyTitle() {
        const $card = $('.section-card');
        $card.each(function () {
            const $this = $(this);
            const $productCard = $this.find('.product-card');
            const $title = $this.find('.section-products__title');
            if ($productCard.length == 0) {
                $title.remove();
            }
        });
    }

    async function hideAccordionCart() {
        $('.cart-accordion-content').each(function () {
            const $content = $(this);
            const $items   = $content.find('.cart-item');
            if ($items.length === 0) {
                $content.closest('.cart-accordion').css('display', 'none');
            }
        });
    }


    function scrollMobile() {
        if ($(window).width() > 768)return;
        const $section = $("#section-products");
        const $sectionCart = $(".section-products__cart");
        const offset = 300;
        $sectionCart.hide();
        $(window).on("scroll", function () {
            const sectionTop = $section.offset().top; 
            const scrollTop = $(window).scrollTop();

            if (scrollTop >= sectionTop - offset) {
                $sectionCart.fadeIn();
                $('.chat-icon').css('bottom', '19%');
            } else {
                $sectionCart.fadeOut();
                $('.chat-icon').css('bottom', '5%');
            }
        });
    }

    //função para fazer scroll até a seção das meals
    function initPartner() {
        const pageHandle = sessionStorage.getItem('page_handle') || null;
        if(pageHandle == "meal-plan-offer") return;
        const el = document.getElementById('section-products__header');
        if (el) {
        const offset = -90;
        const y =
            el.getBoundingClientRect().top +
            window.pageYOffset +
            offset;

        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
        }
    }

    function verifyDiscount() {
        const pageHandle = sessionStorage.getItem('page_handle') ?? '';
        const storage = localStorage.getItem(key);
        const quizComplete = storage ? JSON.parse(storage).winner : null;
        let discount = "null";
        if (pageHandle.includes('partner-')) {
            discount = 'ZS8CZAFQ81MH';
        } else if (quizComplete) {
            discount = 'INTRO_80';
        }


        if(discount=="null") return;
        fetch(`/discount/${discount}`).then(()=> {
            fetch('/cart?view=discount', {}).then(function(res){return res.text();})
            .then(async function(data) {
                let dataObject = JSON.parse(JSON.stringify(data));
                dataObject = JSON.parse(dataObject);
                const appliedCodes = dataObject.discounts.map(i => i.title.trim().toLowerCase());
                if (!appliedCodes.includes(discount.trim().toLowerCase())) {
                    // $('.discount-code-message').text(`Your discount code ${discount} will be applied once your cart reaches $30.`);
                    // $('.discount-code-message').removeClass('hidden');
                }
            })
        });
    }

    function buildFilterComposition() {
        const filters = { proteins: {}, restrictions: {} };
        const noneActive = $('#protein-filter button').filter('.active').length === 0;

        $('#protein-filter button').each(function () {
            const val = $(this).data('value');
            const key = `_no_${String(val).split(':')[1].replaceAll('-', '_')}`;
            const isActive = $(this).hasClass('active');
            filters.proteins[key] = noneActive ? 'false' : (isActive ? 'false' : 'true');
        });

        $('#restriction-filter button').each(function () {
            const val = $(this).data('value');
            const key = `_restriction_${String(val).replaceAll('-', '_')}`;
            filters.restrictions[key] = $(this).hasClass('active') ? 'true' : 'false';
        });

        return JSON.stringify(filters);
    }

    function formatTimestampToDate(timestamp) {
        const date = new Date(Number(timestamp));
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }

    async function verifyQtyMeals(value = null) {
        const getStorage = localStorage.getItem(key);
        const storageObj = getStorage ? JSON.parse(getStorage) : {};

        if (value !== null) {
            storageObj.pk_qty = value;
            localStorage.setItem(key, JSON.stringify(storageObj));
        }
        const pkQty = storageObj.pk_qty || 0;

        $('#qtd-meals-filter button').each(function () {
            const $this = $(this);
            const btnValue = $this.data('value');
            if (btnValue == pkQty) {
                $this.addClass('selected');
            } else {
                $this.removeClass('selected');
            }
        });
    }

    const loading = {
        template: `<div class="loading-overlay__spinner">
          <svg  aria-hidden="true"  focusable="false"  class="w-6 h-5 animate-rotator"  viewBox="0 0 66 66"  xmlns="http://www.w3.org/2000/svg">
            <circle class="animate-dash path stroke-gray-500" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>`
    }
    //verifica se os produtos brinde estão no carrinho ou não, se sim esconde o quantity 
    async function verifyGift() {
        const giftProductIds = [44731949252787];
        const cart = await FormEvents.getCart();
        for (const productId of giftProductIds) {
            const productInCart = cart.items.find(item => item.id === productId);
            if (productInCart) {
                $(`.cart-item[data-variant-id="${productId}"]`).find('.quantity-wrapper').addClass('hidden');
            }
        }
    }

    //função para adicionar brinde ao carrinho se não tiver no carrinho. Se já tiver, não adiciona novamente
    async function addGiftPartnerProducts() {
        const giftProductIds = [44731949252787];
        const cart = await FormEvents.getCart();
        const itemsToAdd = [];
        for (const productId of giftProductIds) {
            const productInCart = cart.items.find(item => item.id === productId);

            if (!productInCart) {
                itemsToAdd.push({
                    id: productId,
                    quantity: 1,
                    properties: {
                        "Option" : "gift",
                    },
                });
            }
        }
        if (itemsToAdd.length > 0) {
            await FormEvents.addItems(itemsToAdd);
        }
    }
    //função para remover o brinde do carrinho
    async function removeGiftPartnerProducts() {
        const giftProductIds = [44731949252787];
        const cart = await FormEvents.getCart();
        for (const item of cart.items) {
            if (giftProductIds.includes(item.id)) {
                await FormEvents.updateQuantityItem(item.key, 0);
            }
        }
    }
    
    async function buildDeliveryDatesWidget() {
        const delivery_options = await waitForKey("delivery_dates_and_cut_offs");
        if (!delivery_options) return;

        const $select = $(".delivery-pickup-widget .select-date");
        if ($select.hasClass("initialized")) return;

        const { sunday, wednesday } = delivery_options.next_available_dates;
        const dates = [sunday, wednesday].map(({ timestamp }) => {
            const date = new Date(timestamp);
            return (date.getDate() === 25 && date.getMonth() === 11 && date.getFullYear() === 2024)
            ? new Date(2025, 0, 1).getTime()
            : timestamp;
        });

        if (sunday.show_sunday) {
            $("<option>")
            .val(dates[0])
            .text(formatDate(dates[0]))
            .appendTo($select);
        }

        if (wednesday.show_wednesday) {
            $("<option>")
            .val(dates[1])
            .text(formatDate(dates[1]))
            .appendTo($select);
        }

        $select.addClass("initialized");
    };

    const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate();
    const suffix = ["st", "nd", "rd"][((day % 10) - 1)] || "th";
    const dayName = date.toLocaleString("en-CA", { weekday: "long" });
    const month = date.toLocaleString("en-CA", { month: "short" });
    const year = date.getFullYear();
    return `${dayName} - ${month} ${day}${suffix}, ${year}`;
    };

    const waitForKey = (key, interval = 100) =>
        new Promise((resolve) => {
            const check = () => {
            const item = localStorage.getItem(key);
            item ? resolve(JSON.parse(item)) : setTimeout(check, interval);
            };
            check();
        });

    $(document).on("submit", 'form[action*="/cart/add"]', async function (e) {
        e.preventDefault();
        const $form = $(this);
        try {
            const originalTextBtn = $(this).find('#AddToCartButton').html();
            $(this).find('#AddToCartButton').empty().html(loading.template);
            await FormEvents.addItem($form.serialize());
            await verifyDiscount();
            await CartDrawerAPI.buildCart();
            await CartDrawerAPI.changeAtcButtonText();
            $(this).find('#AddToCartButton').empty().html(originalTextBtn);
        } catch (err) {
            console.error("Erro ao adicionar item ao carrinho:", err);
        }
    });
    
    $(document).on('click', '#AddToCartModal', async function (e) {
        e.preventDefault();
        const variantId = $(this).data('variant');
        $(this).empty().html(loading.template);
        $(`.product-card[data-variant-id="${variantId}"]`).find('form').trigger('submit');
        await CartDrawerAPI.buildCart();
        $(this).empty().html(`
            <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.60128 10.6499L0.670898 6.71952L2.46204 4.92838L4.60128 7.07395L10.8544 0.814453L12.6456 2.60559L4.60128 10.6499Z" fill="#7ED22A"/>
            </svg>
            Added
        `);
    });
    $(document).on('click', '.cart-item-remove', async function (e) {
        const $item = $(this).closest('.cart-item');
        const itemKey = $item.data('key');
        await FormEvents.updateQuantityItem(itemKey, 0);
        await CartDrawerAPI.buildCart();
        await CartDrawerAPI.changeAtcButtonText();
    });
    $(document).on('click', '.minus-btn, .plus-btn', async function (e) {
        const $item = $(this).closest('.cart-item');
        const itemKey = $item.data('key');
        const $quantityElement = $item.find('.quantity-input');
        let quantity = parseInt($quantityElement.val(), 10);
        if ($(this).hasClass('minus-btn')) {
            if (quantity <= 1) {
                quantity = 0;
            } else {
                quantity -= 1;
            }
        } else if ($(this).hasClass('plus-btn')) {
            quantity += 1;
        }

        try {
            await FormEvents.updateQuantityItem(itemKey, quantity);
            await CartDrawerAPI.buildCart();
            await CartDrawerAPI.changeAtcButtonText();
        } catch (error) {
            console.error(error);
        }
    });
    $(document).on('click', '#cart-clear', async function (e) {
        e.preventDefault();
        try {
            await FormEvents.clearCart();
            await CartDrawerAPI.buildCart();
            await CartDrawerAPI.changeAtcButtonText();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'clear_cart_click'
            });
        } catch (err) {
            console.error("Error clear cart:", err);
        }
    });
    $(document).on('click', '#product-form-minus, #product-form-plus', async function (e) {
        e.preventDefault();
        const $formId = $(this).closest('form').data('productid');
        const $cartId = $(`.cart-item[data-product-id="${$formId}"]`);
        const $itemKey = $cartId.data('key');
        const $quantityElement = $cartId.find('.quantity-input');
        const $formQuantity = $(this).closest('form').find('#product-form-quantity');
        let quantity = parseInt($quantityElement.val(), 10);
        if ($(this).hasClass('minus-btn-quantity')) {
            if (quantity <= 1) {
                quantity = 0;
            } else {
                quantity -= 1;
            }
        } else if ($(this).hasClass('plus-btn-quantity')) {
            quantity += 1;
        }
        
        try {
            $formQuantity.empty().html(loading.template);
            await FormEvents.updateQuantityItem($itemKey, quantity);
            await CartDrawerAPI.buildCart();
            $formQuantity.empty().text(quantity);
            await CartDrawerAPI.changeAtcButtonText();
        } catch (error) {
            console.error(error);
        }
    });
    /* MONTAGEM DO CARRINHO E MUDANÇA DO TEXTO NO BOTÃO*/
    $(document).ready( async function(){
        try {
            await initPartner();
            await scrollMobile();
            await verifyDiscount();
            await CartDrawerAPI.buildCart();
            await CartDrawerAPI.changeAtcButtonText();
            await hideAccordionCart();
            await verifyQtyMeals();
            await verifyTitle();
            await verifyGift();
        } catch (err) {
            console.error("Error build the cart:", err);
        }
    });
    $(document).on('submit', '#discount-form', async function (e) {
        e.preventDefault();
        const $form = $(this);
        const code = $form.find('input[name="discount"]').val().trim();
        fetch(`/discount/${code}`).then(()=> {
          fetch('/cart?view=discount', {}).then(function(res){return res.text();})
            .then(async function(data) {
                let dataObject = JSON.parse(JSON.stringify(data));
                dataObject = JSON.parse(dataObject);
                const appliedCodes = dataObject.discounts.map(i => i.title.trim().toLowerCase());
                if (appliedCodes.includes(code.trim().toLowerCase())) {
                    $('.discount-info').text(`Discount code applied: ${code}`);
                    $('.discount-info').removeClass('hidden');
                    await CartDrawerAPI.buildCart();
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'discount_applied',
                        discount_code: code
                    });
                } else {
                    $('.discount-info').text(`${code} is not a valid discount code.`);
                    $('.discount-info').removeClass('hidden');
                    $('.discount-info').addClass('error');
                }
            })
        })
        
    });
    $(document).on('click', '.discount-code-remove', async function (e) {
        e.preventDefault();
        fetch("/checkout?discount=%20");
        await CartDrawerAPI.buildCart();
        $('.discount-info').addClass('hidden').empty();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'discount_removed',
        });
    });
    $(document).on('click', '.icon-info', async function (e) {
        e.preventDefault();
        const $productCard = $(this).closest('.product-card');
        const productHandle = $productCard.data('product-handle');
        const productTitle = $productCard.data('product-short-title');
        const productId = $productCard.data('product-id');
        const productVariantId = $productCard.data('variant-id');
        const product = await $.ajax({url: `/products/${productHandle}?section_id=card-modal`});
        const parser = new DOMParser();
        const cartItemsContent = parser.parseFromString(product, 'text/html');
        const $listItems = $(cartItemsContent).find('#card-modal');
        $('#modal-content').empty().html($listItems);
        $('.card-modal-wrapper').css('display', 'flex');
        $('body').addClass('no-scroll');
        const caracteresMax = 150;
        const seeMoreText = $('.show-more-description');
        seeMoreText.each(function () {
            const description = $(this).prev();
            if(description.text().trim().length > caracteresMax) {
                $(this).removeClass('hidden');
            }
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'product_modal_opened',
            product_handle: productHandle,
            title: productTitle,
            product_id: productId,
            variant_id: productVariantId
        });
    });
    $(document).on('click', '.modal-overlay, .close-modal', async function (e) {
        e.preventDefault();
        $('.card-modal-wrapper').css('display', 'none');
        $('body').removeClass('no-scroll');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'product_modal_closed'
        });
    });
    $(document).on('click', '.section-products__filters span', async function (e) {
        e.preventDefault();
        const filter = $(this).data('value');
        $(`.filter-container button[data-value="${filter}"]`).trigger('click');
    });
    $(document).on('click', '#button-filter', function (e) {
        if ($(e.target).closest('.filter-dropdown').length) return;
        e.preventDefault();
        $(this).find('.filter-dropdown').toggleClass('hidden');
    });
    $(document).on('click', '.filter-dropdown__close', function (e) {
        e.preventDefault();
        $(this).closest('.filter-dropdown').addClass('hidden');
    });
    $(document).on('click', '#qtd-meals-filter button', async function (e) {
        e.preventDefault();
        const $this = $(this);
        verifyQtyMeals($this.data('value'));
        await CartDrawerAPI.buildCart();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'quantity_filter_click',
            quantity_selection: $this.data('value')
        });
    });
    $(document).on('click', '#complete-cart', async function (e) {
        e.preventDefault();
        try {
            const originalText = $(this).html();
            $(this).empty().html(loading.template);
            await CartDrawerAPI.initCart();
            await CartDrawerAPI.buildCart();
            $(this).empty().html(originalText);
            await CartDrawerAPI.changeAtcButtonText();
            if ($(window).width() <= 768) {
                const el = document.querySelector('#product-list');
                if (!el) return;
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                $('.see-more').trigger('click');
            }
            const storage = localStorage.getItem(key);
            const pkQty = storage ? JSON.parse(storage)?.pk_qty || 6 : $('.qtd-meal-btn.selected').data('pk-qty') || 6;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'add_meals_to_cart_click',
                quantity_selection: pkQty
            });
        } catch (err) {
            console.error("Error initializing cart:", err);
        }
    });
    $(document).on('click', '.go-to-checkout', async function (e) {
        e.preventDefault();
        const $btn = $(this);
        $btn.prop('disabled', true).text('processing...');
        const $selectDelivery = String($('.delivery-pickup-widget').find('.select-delivery').val());
        const $selectDate = parseInt($('.delivery-pickup-widget').find('.select-date').val(), 10);
        const date = formatDate($selectDate);
        await FormEvents.addAttributes({'_plan': 'Custom Meal Plan'});
        await FormEvents.addAttributes({ _filter: buildFilterComposition() });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'go_to_checkout_button_click',
            source: "custom-meal-plan"
        });
        
        const pageHandle = sessionStorage.getItem('page_handle') ?? '';
        if (pageHandle.includes('partner-')) {
            await FormEvents.addAttributes({'_origin_page': pageHandle}); 
            await addGiftPartnerProducts();
            return window.location.href = '/checkout?discount=72YBNR2P32R5,5B3A9NHS18RR,ZS8CZAFQ81MH';
        } else {
            await removeGiftPartnerProducts();
            return window.location.href = '/checkout?discount=%20';
        }
    });

    // Sincronizar selects de delivery
    $(document).on("change", ".select-delivery", function () {
        const selectedValue = $(this).val();
        $(".select-delivery").not(this).val(selectedValue);
    });

    // Sincronizar selects de date
    $(document).on("change", ".select-date", function () {
        const selectedValue = $(this).val();
        $(".select-date").not(this).val(selectedValue);
    });

    $(document).on("change", ".delivery-pickup-widget select", function () {
        let formattedDate;
        let selectedValue;
        if ($(this).hasClass("select-date")) {
            const selectedTimestamp = parseInt($(this).val(), 10);
            formattedDate = formatDate(selectedTimestamp);
            selectedValue = $(".select-delivery").val();
        }
        if ($(this).hasClass("select-delivery")) {
            selectedValue = $(this).val();
            const selectedTimestamp = parseInt($(".select-date").val(), 10);
            formattedDate = formatDate(selectedTimestamp);
        }
        if (selectedValue === "pickup") {
            $(".pickup-address").removeClass("hidden");
        } else {
            $(".pickup-address").addClass("hidden");
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'delivery_method_changed',
            delivery_pickup_selection: formattedDate,
            delivery_type: selectedValue
        });
    });

    $(document).on('click', '.see-more', async function (e) {
        const $this = $(this).closest('.section-products__cart');
        $this.toggleClass('show-cart');
        if ($this.hasClass('show-cart')) {
            $this.find('.see-more-text').text("See less");
            $('body').addClass('no-scroll');
        } else {
            $this.find('.see-more-text').text("See more");
            $('body').removeClass('no-scroll');
        }
    });
    $(document).on('click', '.see-all', function (e) {
        const card = e.target.closest('.product-card');
        $(card).find(`.icon-info`).trigger('click');
    });
    $(document).on('click', '.cart-accordion-header', async function (e) {
        const $this = $(this).closest('.cart-accordion');
        $this.toggleClass('hide-content');
    });
    $(document).on('buildcart', async function() {
        await hideAccordionCart();
    })
    $(document).on('click', '.show-more-description', async function (e) {
        $(this).prev().toggleClass('expanded');
        $(this).text(
            $(this).prev().hasClass('expanded') ? 'Show less' : 'Show more'
        );
    });
    $(document).on('click', '.chat-icon, .chat-icon svg', async function (e) {
        const $this = $(this).closest('.chat-icon');
        $('#zsiq_float').trigger('click');
    });
});
